import { IAdminToolItem, IAdminToolsResponse, IProductPlanPackageTool } from '../../models/ProductPlanPackageTool';
import { productToolResources } from '../builders/productToolResources';
import { getUseResource } from '../resource';

export interface IProductToolPayload {
  name: string;
  isAddon: boolean;
  archived: boolean;
}

interface IAdminToolMutationResponse {
  status: number;
  message: string;
  data: IAdminToolItem;
}

const mapTool = (tool: IAdminToolItem): IProductPlanPackageTool => ({
  id: tool.id,
  name: tool.name,
  isAddon: tool.isAddon,
  archived: tool.archived,
  bundledTools: tool.bundledTools ?? [],
});

const mapToolMutationResponse = (body: IAdminToolMutationResponse): IProductPlanPackageTool => mapTool(body.data);

/** `bundledTools` is rejected as input — bundles have no write endpoint yet. */
const mapToolMutationRequest = (payload: IProductToolPayload) => ({
  name: payload.name,
  isAddon: payload.isAddon,
  archived: payload.archived,
});

/** Request all tools at once — consumers (grids, transfer lists) expect the full list. */
const getToolsQueryParams = () => ({ page: 1, page_size: 1000 });

export const apiProductTool = {
  useGetProductTools: getUseResource(
    productToolResources.getTools,
    (body: IAdminToolsResponse): { tools: IProductPlanPackageTool[] } => ({
      tools: body.data.data.map(mapTool),
    }),
    getToolsQueryParams
  ),
  useAddTool: getUseResource(
    productToolResources.createTool,
    mapToolMutationResponse,
    (params, payload: IProductToolPayload) => mapToolMutationRequest(payload)
  ),
  useUpdateTool: getUseResource(
    productToolResources.updateTool,
    mapToolMutationResponse,
    (params, payload: IProductToolPayload) => mapToolMutationRequest(payload)
  ),
  useDeleteTool: getUseResource(productToolResources.deleteTool, () => null),
};
